import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_29: FaireProductEntity = {
  token: "legacy_prod_abbott-29",
  type: "product",
  name: 'Tall Bud Vase Dark Blue 7.5" H',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/01402844248dd09dbc3bdbc98b1a2128e9e15a002db05e91532f5fc3f332aba4.jpeg",
  priceDollars: 18,
  subcategory: "Vases & Vessels",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_home-accents"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
